<template>
  <div class="home-tab">
    <div class="home__top-banner" />
    <div class="home__header">
      <div v-if="hadLogin" class="home__header--login">
        <div class="home__header-left">
          <div class="home__header-welcome">欢迎</div>
          <div class="home__header-user">{{ username }}</div>
          <div class="home__header-btn-logout" @click="onPopupLogout">
            退出登录
          </div>
        </div>
        <!-- <div class="home__header-right">立即兑换</div> -->
      </div>
      <div v-else class="home__header--unlogin">
        <div class="home__header-welcome">欢迎</div>
        <div class="home__header-btn-login" @click="onPopupLogin">点击登录</div>
      </div>
    </div>
    <div class="home__hot-activity">
      <div class="home__hot-activity-title">
        <div class="home__arrow-left" />
        人气活动·专属福利
        <div class="home__arrow-right" />
      </div>
      <div class="home__hot-activity-first">
        <img
          v-for="(link, index) in linksOfStandardAndWednesday"
          :src="link.image"
          :key="index"
          @click="onRoute(hadLogin ? link.loginedUrl : link.unLoginedUrl)"
        />
      </div>
      <div class="home__hot-activity-second">
        <img
          v-for="(link, index) in linksOfOtherHot"
          :src="link.image"
          :key="index"
          @click="onRoute(hadLogin ? link.loginedUrl : link.unLoginedUrl)"
        />
      </div>
    </div>
    <div class="home__middle-banner">
      <img
        v-for="(link, index) in linksOfAd"
        :src="link.image"
        :key="index"
        @click="onRoute(hadLogin ? link.loginedUrl : link.unLoginedUrl)"
      />
    </div>
    <div class="home__hot-activity">
      <div class="home__hot-activity-title">
        <div class="home__arrow-left" />
        活动超市·多彩福利
        <div class="home__arrow-right" />
      </div>
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item
          v-for="(linkGroup, groupIndex) in linksOfNormal"
          :key="groupIndex"
        >
          <div class="home__hot-activity-second">
            <img
              v-for="(link, index) in linkGroup"
              :src="link.image"
              :key="index"
              @click="onRoute(hadLogin ? link.loginedUrl : link.unLoginedUrl)"
            />
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>

    <van-dialog
      v-model:show="isLoginPopupVisble"
      show-cancel-button
      confirm-button-text="立即登录"
      :beforeClose="validateLogin"
      @confirm="onLogin"
    >
      <div class="login-form">
        <div class="login-title">登录</div>
        <div class="login-row">
          <div class="login-label">用户名：</div>
          <input
            class="login-input"
            placeholder="请输入用户名"
            v-model="username"
          />
        </div>
        <div class="login-row">
          <div class="login-label">手机号后六位：</div>
          <input
            class="login-input"
            pattern="[0-9]*"
            type="tel"
            placeholder="请输入手机号后六位"
            v-model="mobile"
            @input="onMobileInput"
          />
        </div>
        <div class="login-row">
          <div class="login-label">身份证号后六位：</div>
          <input
            class="login-input"
            type="text"
            placeholder="请输入身份证号后六位"
            v-model="credentials"
            @input="onCredentialsInput"
          />
        </div>
        <div class="login-tip">*请输入华夏银行预留信息</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import useLogin from '../hooks/useLogin'
import useHomeLogic from '../hooks/useHomeLogic'

export default {
  setup() {
    const {
      hadLogin,
      isLoginPopupVisble,
      username,
      mobile,
      credentials,
      validateLogin,
      onPopupLogin,
      onMobileInput,
      onCredentialsInput,
      onLogin,
      onPopupLogout
    } = useLogin()
    const {
      linksOfStandardAndWednesday,
      linksOfOtherHot,
      linksOfAd,
      linksOfNormal,
      onRoute
    } = useHomeLogic()

    return {
      hadLogin,
      isLoginPopupVisble,
      username,
      mobile,
      credentials,
      validateLogin,
      onMobileInput,
      onPopupLogin,
      onCredentialsInput,
      onPopupLogout,
      onLogin,

      linksOfStandardAndWednesday,
      linksOfOtherHot,
      linksOfAd,
      linksOfNormal,
      onRoute
    }
  }
}
</script>

<style lang="less" scoped>
.home-tab {
  background: #f8f8f8;
  min-height: 100vh;
  padding-bottom: 60px;
  .home__top-banner {
    width: 375px;
    height: 127px;
    background-image: url('../../../../assets/home-top-banner.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .home__header {
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.1);
    .home__header--login {
      display: flex;
      height: 42px;
      justify-content: space-between;
      padding: 0 15px;
      margin-top: -10px;
      .home__header-left {
        display: flex;
        align-items: center;
        .home__header-welcome {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ff0000;
        }
        .home__header-user {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #666666;
          margin-left: 8px;
        }
        .home__header-btn-logout {
          width: 82px;
          height: 28px;
          background: #ff2115;
          border-radius: 14px;
          margin-left: 15px;

          display: flex;
          align-items: center;
          justify-content: center;

          font-size: 15px;
          font-family: Source Han Sans CN;
          font-weight: bolder;
          color: #ffffff;
        }
        .home__header-btn-logout:active {
          opacity: 0.5;
        }
      }
      .home__header-right {
        width: 61px;
        height: 17px;
        background: #ffffff;
        border: 1px solid #ff2a1c;
        border-radius: 9px;

        font-size: 11px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 4px;
      }
    }
    .home__header--unlogin {
      display: flex;
      align-items: center;
      height: 42px;
      padding: 0 15px;
      margin-top: -10px;
      .home__header-welcome {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ff0000;
      }
      .home__header-btn-login {
        width: 82px;
        height: 28px;
        background: #ff2115;
        border-radius: 14px;
        margin-left: 15px;

        display: flex;
        align-items: center;
        justify-content: center;

        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: bolder;
        color: #ffffff;
      }
      .home__header-btn-login:active {
        opacity: 0.5;
      }
    }
  }
  .home__hot-activity {
    width: 345px;
    background: #ffffff;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.35);
    border-radius: 2px;
    margin-top: 12px;
    margin-left: 15px;
    padding-bottom: 15px;
    overflow: hidden;
    .home__hot-activity-title {
      display: flex;
      align-items: center;
      justify-content: center;

      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      margin-top: 13px;
      .home__arrow-left {
        width: 31px;
        height: 2px;
        background-image: url('../../../../assets/home-arrow-left.png');
        background-repeat: no-repeat;
        background-size: 100%;
        margin-right: 6px;
      }
      .home__arrow-right {
        width: 31px;
        height: 2px;
        background-image: url('../../../../assets/home-arrow-right.png');
        background-repeat: no-repeat;
        background-size: 100%;
        margin-left: 6px;
      }
    }
    .home__hot-activity-first {
      margin: 10px 13px 0 13px;
      display: flex;
      justify-content: space-between;
      img {
        width: 153px;
        height: 74px;
      }
    }
    .home__hot-activity-second {
      margin: 10px 13px 0 13px;
      display: flex;
      justify-content: space-between;
      img {
        width: 97px;
        height: 107px;
      }
    }
  }
  .home__middle-banner {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    img {
      width: 370px;
      height: 116px;
    }
  }
  .login-form {
    .login-title {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
      text-align: center;
      margin-top: 26px;
    }
    .login-row {
      display: flex;
      align-items: center;
      margin-top: 17px;
      .login-label {
        min-width: 120px;
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #121212;
        text-align: right;
      }
      .login-input {
        width: 160px;
        height: 30px;
        background: #f2f2f2;
        border: 1px solid #cccccc;
        border-radius: 5px;
        padding: 0;
        padding-left: 3px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        -webkit-appearance: none;
      }
    }
    .login-tip {
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ff2115;
      text-align: center;
      margin: 17px 0;
    }
  }
}
</style>
